import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS, VERIFY_LOGIN_OTP_SUCCESS } from '../types/auth';
import { CREATE_APPLICATION_SUCCESS } from '../types/application';

export type ParamsPropsNct = {
  page: number;
  search: string;
  applicationType: string;
  status: string;
  modeOfHolding: string;
  distributorId: string;
  kycStatus: string;
  riskCategory: string;
  schemeId: string;
  planId: string;
};

export const initialStateNct: ParamsPropsNct = {
  page: 1,
  applicationType: '',
  status: '',
  search: '',
  modeOfHolding: '',
  distributorId: '',
  kycStatus: '',
  riskCategory: '',
  schemeId: '',
  planId: '',
};

function paramsReducerNct(state = initialStateNct, action: AnyAction): Partial<ParamsPropsNct> {
  switch (action.type) {
    case VERIFY_LOGIN_OTP_SUCCESS: {
      // console.log(action.body.role);
      return {
        ...state,
        status:
          action.body.role === 'amcapprover' && action.body.roleType === 'approver1'
            ? 'completed'
            : '',
      };
    }
    case 'GET_NCT_PARAMS_DATA':
      return {
        ...state,
        page: action.paramsObj.page,
        applicationType: action.paramsObj.applicationType,
        status: action.paramsObj.status,
        modeOfHolding: action.paramsObj.modeOfHolding,
        distributorId: action.paramsObj.distributorId,
        search: action.paramsObj.search,
        kycStatus: action.paramsObj.kycStatus,
        riskCategory: action.paramsObj.riskCategory,
        schemeId: action.paramsObj.schemeId,
        planId: action.paramsObj.planId,
      };
    case LOGOUT_SUCCESS: {
      return { ...initialStateNct };
    }
    default:
      return state;
  }
}

export default paramsReducerNct;
